import { useDispatch as useDispatchRedux } from 'react-redux';
import { useLocation as useLocationRedux, useNavigate as useNavigateRedux } from 'react-router-dom';

import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../store';

import { useGetCarousel } from './useGetCarousel';
import { useGetDishes } from './useGetDishes';
import { useGetMenu } from './useGetMenu';
import { useGetNotifications } from './useGetNotifications';
import { useGetOrders } from './useGetOrders';
import { useGetPromocodes } from './useGetPromocodes';
import { useGetReviews } from './useGetReviews';

import { useOpacity } from './useOpacity';
import { useScrollToTop } from './useScrollToTop';
import { useThemeColor } from './useThemeColor';

import { useCartHandler } from './useCartHandler';
import { useGetConfiguration } from './useGetConfiguration';
import { useWishlistHandler } from './useWishlistHandler';

export const useNavigate = () => useNavigateRedux();
export const useDispatch = () =>
  useDispatchRedux<ThunkDispatch<RootState, void, Action>>();
export const useLocation = () => useLocationRedux();

export const hooks = {
  useGetMenu,
  useOpacity,
  useNavigate,
  useDispatch,
  useLocation,
  useGetDishes,
  useGetOrders,
  useGetReviews,
  useThemeColor,
  useCartHandler,
  useGetCarousel,
  useScrollToTop,
  useGetPromocodes,
  useWishlistHandler,
  useGetNotifications,
  useGetConfiguration
};
